import { render, staticRenderFns } from "./ChurchRecord.vue?vue&type=template&id=d93b8cde&scoped=true&"
import script from "./ChurchRecord.vue?vue&type=script&lang=js&"
export * from "./ChurchRecord.vue?vue&type=script&lang=js&"
import style0 from "./ChurchRecord.vue?vue&type=style&index=0&id=d93b8cde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93b8cde",
  null
  
)

export default component.exports